<template>
  <section class="mt-10">
    <nav
      aria-label="Breadcrumb"
      class="flex"
    >
      <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        <li class="inline-flex items-center">
          <a
            class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white"
            href="#"
          >
            Admin
          </a>
        </li>
        <li>
          <div class="flex items-center">
            <svg
              aria-hidden="true"
              class="w-3 h-3 mx-1 text-gray-400 rtl:rotate-180"
              fill="none"
              viewBox="0 0 6 10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m1 9 4-4-4-4"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <a
              class="text-sm font-medium text-black ms-1 hover:text-primary md:ms-2 dark:text-white dark:hover:text-white"
              href="#"
            >Users</a>
          </div>
        </li>
      </ol>
    </nav>
    <div class="flex flex-col items-start justify-between gap-4 mt-6 space-y-3 md:flex-row md:space-y-0">
      <form
        class="w-full"
        @submit.prevent="updateUser"
      >
        <h2 class="mb-4 text-xl font-semibold leading-none text-gray-900 dark:text-white">
          General Information
        </h2>
        <div class="grid gap-4 mb-4 md:gap-6 md:grid-cols-2 sm:mb-8">
          <div>
            <label
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="first-name"
            >Full
              Name</label>
            <input
              id="first-name"
              v-model="user.fullName"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              name="first-name"
              placeholder="Ex. John"
              type="text"
            >
          </div>
          <div>
            <label
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="company"
            >Company</label>
            <input
              id="company"
              v-model="user.company"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              name="company"
              placeholder="Ex. Nevcap Ventures"
              type="text"
            >
          </div>
          <div>
            <label
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="email"
            >Email</label>
            <input
              id="email"
              v-model="user.email"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              name="email"
              placeholder="Ex. name@company.com"
              required
              type="email"
              value="helene@company.com"
            >
          </div>
          <div>
            <label
              class="inline-flex items-center mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="membership-plan"
            >
              Membership Plan
            </label>
            <select
              id="membership-plan"
              v-model="user.membershipPlan"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              <option value="community">
                Community
              </option>
              <option value="community_plus">
                Community Plus
              </option>
            </select>
          </div>
          <div>
            <div class="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Setup Completed
            </div>
            <label
              class="inline-flex relative items-center cursor-pointer"
              for="setup-completed"
            >
              <input
                id="setup-completed"
                v-model="user.setupCompleted"
                class="sr-only peer"
                type="checkbox"
              >
              <span
                class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600"
              />
              <span class="ml-3 text-sm font-medium text-gray-500 dark:text-gray-300">Completed</span>
            </label>
          </div>
          <div>
            <label
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="phoneNumber"
            >Phone Number</label>
            <input
              id="phoneNumber"
              v-model="user.phoneNumber"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              name="phoneNumber"
              placeholder="Ex. +44 20 1234 5678"
              type="text"
            >
          </div>
          <div>
            <label
              class="inline-flex items-center mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="user-role"
            >
              User Role
            </label>
            <select
              id="user-role"
              v-model="user.role"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              <option value="admin">
                Admin
              </option>
              <option value="user">
                User
              </option>
            </select>
          </div>
          <div>
            <label
              class="inline-flex items-center mb-2 text-sm font-medium text-gray-900 dark:text-white"
              for="email-status"
            >
              Email Verification
            </label>
            <select
              id="email-status"
              v-model="user.verified"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              <option value="true">
                Verified
              </option>
              <option value="false">
                Unverified
              </option>
            </select>
          </div>
          <div>
            <div class="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Account Status
            </div>
            <label
              class="inline-flex relative items-center cursor-pointer"
              for="user-status"
            >
              <input
                id="user-status"
                v-model="user.isActive"
                class="sr-only peer"
                type="checkbox"
                value=""
              >
              <span
                class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600"
              />
              <span class="ml-3 text-sm font-medium text-gray-500 dark:text-gray-300">Active</span>
            </label>
          </div>
        </div>
        <button
          class="inline-flex items-center px-5 py-3 text-sm font-medium text-center text-white bg-black rounded-lg hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
          type="submit"
        >
          Update User
        </button>
      </form>
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent, onMounted, reactive, toRefs, watchEffect} from 'vue';
import axios from 'axios';
import {User} from '@/types';
import {useHead} from '@vueuse/head';

export default defineComponent({
  name: "User",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      enabled: true,
      user: {} as User,
      loading: false,
      error: null as string | null,
      modals: {} as Record<string, boolean>,
    });

    watchEffect(() => {
      if (state.user.fullName) {
        useHead({
          title: state.user.fullName,
        });
      }
    });

    const fetchUser = async () => {
      state.loading = true;
      try {
        const response = await axios.get(`user/detail/${props.id}`);
        state.user = response.data;
      } catch (error) {
        state.error = "User not found.";
      } finally {
        state.loading = false;
      }
    };

    onMounted(fetchUser);

    const updateUser = async () => {
      state.loading = true;
      try {
        const response = await axios.put(`user/update/${state.user._id}`, state.user);
        state.user = response.data;
      } catch (error) {
        console.error('Failed to update user:', error);
      } finally {
        state.loading = false;
      }
    };

    return {
      ...toRefs(state),
      updateUser,
    };
  },
});
</script>
